import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { Subject, ReplaySubject, debounceTime, takeUntil } from 'rxjs';

@Component({
  selector: 'app-price-selection',
  templateUrl: './price-selection.component.html',
  styleUrls: ['./price-selection.component.scss']
})
export class PriceSelectionComponent implements OnInit {
  @Input() formDetails: any = {};
  rowHeightDisplay: number = 50;
  gutterSizeDisplay: number = 5;
  rowHeight: number = 30;
  gutterSize: number = 5;
  rowHeightContent: number = 50;
  gutterSizeContent: number = 5;
  @Input() selectedValues: any = {};
  @Output() onSelectFilter: any = new EventEmitter<any>();
  @Output() onResetFilter: any = new EventEmitter<any>();
  searchUserForm!: FormGroup;
  @ViewChild('allRegion') private allRegion!: MatOption;
  @ViewChild('allBusinessView') private allBusinessView!: MatOption;
  @ViewChild('allSubBusinessView') private allSubBusinessView!: MatOption;
  @ViewChild('allChannelType') private allChannelType!: MatOption;
  @ViewChild('allChannel') private allChannel!: MatOption;
  @ViewChild('allCustomerName') private allCustomerName!: MatOption;
  @ViewChild('allLobSegment') private allLobSegment!: MatOption;
  @ViewChild('allEngineModel') private allEngineModel!: MatOption;
  @ViewChild('allWaveInitiative') private allWaveInitiative!: MatOption;
  @ViewChild('allClassification') private allClassification!: MatOption;
  @ViewChild('allProductFlag') private allProductFlag!: MatOption;

  public searchRegion: FormControl = new FormControl();
  public searchBusinessView: FormControl = new FormControl();
  public searchSubBusinessView: FormControl = new FormControl();
  public searchCustomerName: FormControl = new FormControl();
  public searchChannelType: FormControl = new FormControl();
  public searchChannel: FormControl = new FormControl();
  public searchLobSegment: FormControl = new FormControl();
  public searchEngineModel: FormControl = new FormControl();
  public searchWaveInitiative: FormControl = new FormControl();
  public searchClassification: FormControl = new FormControl();
  public searchProductFlag: FormControl = new FormControl();

  protected _onDestroy = new Subject<void>();
  public filteredRegion: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredBusinessView: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredChannelType: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredChannel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredCustomerName: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredSubBusinessView: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredLobSegment: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredEngineModel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredWaveInitiative: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredClassification: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredProductFlag: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  data: any;

  constructor(private fb: FormBuilder) { }
  ngOnChanges(changes: SimpleChanges): void {
    this.filteredRegion.next(this.formDetails['financial_reporting_region']?.slice());
    this.filteredBusinessView.next(this.formDetails['business_view']?.slice());
    this.filteredSubBusinessView.next(this.formDetails['sub_business_view']?.slice());
    this.filteredLobSegment.next(this.formDetails['lob_segment_2']?.slice());
    this.filteredChannelType.next(this.formDetails['type']?.slice());
    this.filteredEngineModel.next(this.formDetails['revised_product_family_standard']?.slice());
    this.filteredChannel.next(this.formDetails['channel_new']?.slice());
    this.filteredCustomerName.next(this.formDetails['revised_customer_name']?.slice());
    this.filteredWaveInitiative.next(this.formDetails['wave_initiative']?.slice());
    this.filteredClassification.next(this.formDetails['classification']?.slice());
    this.filteredProductFlag.next(this.formDetails['product_flag']?.slice());
  }
  ngAfterViewInit(): void {

    this.searchUserForm.controls.multiRegion.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'financial_reporting_region') {
          this.onSelectFilter.emit(this.data);
        }
      });

    this.searchUserForm.controls.multiBusinessView.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'business_view') {
          this.onSelectFilter.emit(this.data);
        }
      });

    this.searchUserForm.controls.multiSubBusinessView.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'sub_business_view') {
          this.onSelectFilter.emit(this.data);
        }
      });


    this.searchUserForm.controls.multiLobSegment.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'lob_segment_2') {
          this.onSelectFilter.emit(this.data);
        }
      });

    this.searchUserForm.controls.multiChannelType.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'type') {
          this.onSelectFilter.emit(this.data);
        }
      });
    this.searchUserForm.controls.multiEngineModel.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'revised_product_family_standard') {
          this.onSelectFilter.emit(this.data);
        }
      });
    this.searchUserForm.controls.multiChannel.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'channel_new') {
          this.onSelectFilter.emit(this.data);
        }
      });



    this.searchUserForm.controls.multiCustomerName.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'revised_customer_name') {
          this.onSelectFilter.emit(this.data);
        }
      });

    this.searchUserForm.controls.multiWaveInitiative.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'wave_initiative') {
          this.onSelectFilter.emit(this.data);
        }
      });

    this.searchUserForm.controls.multiClassification.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'classification') {
          this.onSelectFilter.emit(this.data);
        }
      });

    this.searchUserForm.controls.multiProductFlag.valueChanges
      .pipe(debounceTime(800))
      .subscribe(() => {
        if (this.data.type == 'product_flag') {
          this.onSelectFilter.emit(this.data);
        }
      });

  }
  ngOnInit(): void {
    this.searchUserForm = this.fb.group({
      multiRegion: new FormControl(this.selectedValues.financial_reporting_region),
      multiBusinessView: new FormControl(this.selectedValues.business_view),
      multiSubBusinessView: new FormControl(this.selectedValues.sub_business_view),
      multiLobSegment: new FormControl(this.selectedValues.lob_segment_2),
      multiChannelType: new FormControl(this.selectedValues.type),
      multiEngineModel: new FormControl(this.selectedValues.revised_product_family_standard),
      multiChannel: new FormControl(this.selectedValues.channel_new),
      multiCustomerName: new FormControl(this.selectedValues.revised_customer_name),
      multiWaveInitiative: new FormControl(this.selectedValues.wave_initiative),
      multiClassification: new FormControl(this.selectedValues.classification),
      multiProductFlag: new FormControl(this.selectedValues.product_flag),
    });

    this.searchRegion.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRegion();
      });
    this.searchBusinessView.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBusinessView();
      });
    this.searchSubBusinessView.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterSubBusinessView();
      });
    this.searchChannelType.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterChannelType();
      });
    this.searchLobSegment.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterLobSegment();
      });
    this.searchEngineModel.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterEngineModel();
      });
      this.searchChannel.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterChannel();
        });
      this.searchCustomerName.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterCustomerName();
        });
      this.searchWaveInitiative.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterWaveInitiative();
        });

      this.searchClassification.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterClassification();
        });

      this.searchProductFlag.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
          this.filterProductFlag();
        });

  }

  protected filterRegion() {
    let search = this.searchRegion.value;
    search = search.toLowerCase();
    this.filteredRegion.next(
      this.formDetails['financial_reporting_region'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterBusinessView() {
    let search = this.searchBusinessView.value;
    search = search.toLowerCase();
    this.filteredBusinessView.next(
      this.formDetails['business_view'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterSubBusinessView() {
    let search = this.searchSubBusinessView.value;
    search = search.toLowerCase();
    this.filteredSubBusinessView.next(
      this.formDetails['sub_business_view'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterLobSegment() {
    let search = this.searchLobSegment.value;
    search = search.toLowerCase();
    this.filteredLobSegment.next(
      this.formDetails['lob_segment_2'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterChannelType() {
    let search = this.searchChannelType.value;
    search = search.toLowerCase();
    this.filteredChannelType.next(
      this.formDetails['type'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterEngineModel() {
    let search = this.searchEngineModel.value;
    search = search.toLowerCase();
    this.filteredEngineModel.next(
      this.formDetails['revised_product_family_standard'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterChannel() {
    let search = this.searchChannel.value;
    search = search.toLowerCase();
    this.filteredChannel.next(
      this.formDetails['channel_new'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }

  protected filterCustomerName() {
    let search = this.searchCustomerName.value;
    search = search.toLowerCase();
    this.filteredCustomerName.next(
      this.formDetails['revised_customer_name'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterWaveInitiative() {
    let search = this.searchWaveInitiative.value;
    search = search.toLowerCase();
    this.filteredWaveInitiative.next(
      this.formDetails['wave_initiative'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterClassification() {
    let search = this.searchClassification.value;
    search = search.toLowerCase();
    this.filteredClassification.next(
      this.formDetails['classification'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterProductFlag() {
    let search = this.searchProductFlag.value;
    search = search.toLowerCase();
    this.filteredProductFlag.next(
      this.formDetails['product_flag'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }


  changeFilter(event, filter) {
    if (event.includes('All') || event == '') {
      this.data = {
        value: ['All'],
        type: filter,
      };
    } else {
      this.data = {
        value: event,
        type: filter,
      };
    }

  }


  // changeFilter(event, filter) {
  //   if (event.includes('All') || event == '') {
  //     if (
  //       filter == 'base_period' ||
  //       filter == 'current_period' ||
  //       filter == 'level'
  //     ) {
  //       this.data = {
  //         value: 'All',
  //         type: filter,
  //       };
  //     } else {
  //       this.data = {
  //         value: ['All'],
  //         type: filter,
  //       };
  //     }
  //   } else {
  //     this.data = {
  //       value: event,
  //       type: filter,
  //     };
  //   }
  //   if (
  //     filter == 'base_period' ||
  //     filter == 'current_period' ||
  //     filter == 'selection_type' ||
  //     filter == 'level'
  //   ) {
  //     this.onSelectFilter.emit(this.data);
  //   }
  // }
  tosslePerRegion(all) {
    if (this.allRegion.selected) {
      this.allRegion.deselect();
      return false;
    }

    return;
  }
  toggleAll(event) {
    this.searchUserForm.controls[event].patchValue(['All']);
  }

  tosslePerBusinessView(all) {
    if (this.allBusinessView.selected) {
      this.allBusinessView.deselect();
      return false;
    }

    return;
  }

  tosslePerSubBusinessView(all) {
    if (this.allSubBusinessView.selected) {
      this.allSubBusinessView.deselect();
      return false;
    }

    return;
  }
  tosslePerLobSegment(all) {
    if (this.allLobSegment.selected) {
      this.allLobSegment.deselect();
      return false;
    }

    return;
  }
  tosslePerWaveInitiative(all) {
    if (this.allWaveInitiative.selected) {
      this.allWaveInitiative.deselect();
      return false;
    }

    return;
  }

  tosslePerEngineModel(all) {
    if (this.allEngineModel.selected) {
      this.allEngineModel.deselect();
      return false;
    }

    return;
  }

  tosslePerChannel(all) {
    if (this.allChannel.selected) {
      this.allChannel.deselect();
      return false;
    }

    return;
  }
  tosslePerChannelType(all) {
    if (this.allChannelType.selected) {
      this.allChannelType.deselect();
      return false;
    }

    return;
  }

  tosslePerCustomerName(all) {
    if (this.allCustomerName.selected) {
      this.allCustomerName.deselect();
      return false;
    }

    return;
  }

  tosslePerClassification(all) {
    if (this.allClassification.selected) {
      this.allClassification.deselect();
      return false;
    }

    return;
  }

  tosslePerProductFlag(all) {
    if (this.allProductFlag.selected) {
      this.allProductFlag.deselect();
      return false;
    }

    return;
  }

  resetFilter() {

    this.searchUserForm.controls.multiRegion.patchValue(['All']);
    this.searchUserForm.controls.multiBusinessView.patchValue(['All']);
    this.searchUserForm.controls.multiSubBusinessView.patchValue(['All']);
    this.searchUserForm.controls.multiLobSegment.patchValue(['All']);
    this.searchUserForm.controls.multiChannelType.patchValue(['All']);
    this.searchUserForm.controls.multiEngineModel.patchValue(['All']);
    this.searchUserForm.controls.multiChannel.patchValue(['All']);
    this.searchUserForm.controls.multiCustomerName.patchValue(['All']);
    this.searchUserForm.controls.multiWaveInitiative.patchValue(['All']);
    this.searchUserForm.controls.multiClassification.patchValue(['All']);
    this.searchUserForm.controls.multiProductFlag.patchValue(['All']);
    this.onResetFilter.emit(true);
    this.data.type = '';
  }
}
